









import { Component, Vue } from 'vue-property-decorator'
import api, { NotAuthenticated } from '@/services/api'

@Component
export default class extends Vue {
    async created() {
        this.$emit('hide')
        const accessToken = localStorage.getItem('temporaryPartnerAccessToken')
        if (accessToken) {
            try {
                const data = await api.request(
                    'get',
                    'idea-cards/unrated',
                    undefined,
                    {
                        accessToken,
                    }
                )
                this.$emit('show')
            } catch (e) {
                if (e instanceof NotAuthenticated) {
                    this.$emit('hide')
                    localStorage.removeItem('temporaryPartnerAccessToken')
                } else {
                    throw e
                }
            }
        } else {
            this.$emit('hide')
        }
    }
    onTap() {
        ;(navigator as any).share(
            {
                title: 'Sexier Together',
                text: 'test',
                url:
                    location.origin +
                    '/partner/' +
                    localStorage.getItem('temporaryPartnerAccessToken'),
            },
            {
                copy: true,
                email: true,
                print: false,
                sms: true,
                messenger: true,
                facebook: true,
                whatsapp: true,
                twitter: true,
                linkedin: true,
                telegram: true,
                skype: true,
            }
        )
    }
}
